exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "main {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\nmain {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\nmain {\n  height: 100vh; }\n  main section {\n    position: relative;\n    text-align: center; }\n    main section h1 {\n      font-size: 2em; }\n    main section figure.img-arrow {\n      position: absolute;\n      left: -25%;\n      -webkit-transform: rotate(-30deg);\n              transform: rotate(-30deg);\n      bottom: -25%; }\n      main section figure.img-arrow img {\n        height: 80%;\n        width: 80%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Admin/Documents/Dev Projects/search-artist/src/app/home/home.component.scss
// module id = ../../../../../src/app/home/home.component.scss
// module chunks = main